<div [ngClass]="containerClass" class="container-fluid primary-container">
    <div
        [ngClass]="containerType + ' ' + containerGutter"
        class="mb-6 primary-container-title"
    >
        <h1 *ngIf="type === 'h1'" class="title mb-6 mb-sm-0">
            {{ content.title }}
        </h1>
        <p *ngIf="type === 'paragraph'" class="title title-p mb-0">
            {{ content.title }}
        </p>
        <p *ngIf="type === 'h1'" class="subtitle">{{ content.subtitle }}</p>
        <p *ngIf="type === 'paragraph'" class="subtitle subtitle-p mb-4">
            {{ content.subtitle }}
        </p>
    </div>
    <ng-content></ng-content>
</div>
